/**
 * Total number of seats in Parliament.
 */
export const TOTAL_NB_SEATS = 338;

/**
 * Total number of registered electors.
 */
export const TOTAL_NB_REGISTERED_ELECTORS = 27126166;

/**
 * Refresh interval for the data.
 */
export const REFRESH_INTERVAL = 60 * 1000;
